<template>
  <div class="switcher-container">
    <tabs
      class="align-self-start"
      :items="tabs"
      :show-slider="true"
      @change="$emit('change', tabs[$event].id)"
      :selected-index="selectedIndex || 0"
      :pill="true"
      variant="secondary"
    >
      <template v-slot:default="item">
        <div class="d-flex align-items-center" :key="item.item.id">
          <i
            :class="{
              [listViewIcon]: item.item.id === LIST_VIEW,
              ['inverted-bars-icon']: item.item.id === BOARD_VIEW
            }"
          ></i>
          <div class="text-small-1 ml-1 label">{{ item.item.label }}</div>
        </div>
      </template>
    </tabs>
  </div>
</template>

<script>
import Tabs from '@/components/Tabs'
import { BOARD_VIEW, INITIATIVE_VIEWS_TYPES, LIST_VIEW } from '@/constants/initiative'

/**
 * This gives an option to toggle between board view and list view
 */
export default {
  name: 'ViewSwitcher',
  props: ['selected'],
  components: {
    Tabs
  },
  data() {
    return {
      tabs: INITIATIVE_VIEWS_TYPES,
      BOARD_VIEW,
      LIST_VIEW
    }
  },
  computed: {
    selectedIndex() {
      return this.tabs.findIndex(tab => tab.id === this.selected)
    },
    listViewIcon() {
      return this.selected === LIST_VIEW ? 'ham-white-icon' : 'ham-icon'
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
.switcher-container {
  background-color: $documentColor;
  border-radius: 20px;
  padding: 6px;
}
.ham-icon,
.ham-white-icon {
  @include dimension(14px, 14px);
}
.inverted-bars-con {
  @include dimension(14px, 15px);
}
.label {
  color: $prime;
}
</style>
